import React from 'react';
import type { DecoratedCategorizeItem } from './types';
import { GRID_TEMPLATE } from './constants';
import CategoryDropdown from './CategoryDropdown';

interface Props {
  item: DecoratedCategorizeItem;
  onApprove: () => void;
  onDismiss: () => void;
  onChangeCategory: (categoryId: string) => void;
}

function formatDate(iso: string): string {
  const d = new Date(iso);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
}

function formatAmount(n: number): string {
  const abs = Math.abs(n);
  const formatted = abs.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  if (n < 0) return `-$${formatted}`;
  if (n > 0) return `+$${formatted}`;
  return `$${formatted}`;
}

export default function CategorizeRow({ item, onApprove, onDismiss, onChangeCategory }: Props): React.ReactElement {
  const isPositive = item.amount > 0;
  return (
    <div
      className="grid gap-4 items-center py-3.5 px-1 border-b border-lineSoft text-small bg-white hover:bg-[#EEF4FB] transition-colors"
      style={{ gridTemplateColumns: GRID_TEMPLATE }}
    >
      <div className="text-helper text-[12.5px] tabular-nums">{formatDate(item.date)}</div>
      <div className="font-semibold text-ink">{item.description}</div>
      <div className={`text-right font-semibold tabular-nums ${isPositive ? 'text-teal-dark' : 'text-ink'}`}>
        {formatAmount(item.amount)}
      </div>
      <div>
        <CategoryDropdown
          selectedCategoryId={item.selectedCategoryId}
          suggestedCategoryId={item.suggestedCategoryId}
          onChange={onChangeCategory}
        />
      </div>
      <div className="flex gap-1.5 justify-end">
        <button
          type="button"
          onClick={onDismiss}
          className="h-8 px-3 border border-line bg-white text-ink2 text-small font-semibold rounded-md cursor-pointer"
        >
          Dismiss
        </button>
        <button
          type="button"
          onClick={onApprove}
          className="h-8 px-3.5 bg-ink text-white text-small font-bold rounded-md cursor-pointer border-none"
        >
          Approve
        </button>
      </div>
    </div>
  );
}